import { render } from "./CondicionesGeneralesRepresentacionPage.vue?vue&type=template&id=37fbe72c"
import script from "./CondicionesGeneralesRepresentacionPage.vue?vue&type=script&lang=js"
export * from "./CondicionesGeneralesRepresentacionPage.vue?vue&type=script&lang=js"

import exportComponent from "C:\\projects\\Repository\\C318-CAF. Portal de Juntas telematicas\\CAF-Solution\\NetCoreWebApi\\ClientApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__